import type { Span } from "@prismicio/types-internal/lib/content"

type SpanTypeGroup = Partial<Record<Span["type"], Span[]>>

export function groupByType(spans: Span[]): SpanTypeGroup {
  return spans.reduce<SpanTypeGroup>((acc, span) => {
    const spanGroup = (acc[span.type] || []).concat(span)
    return { ...acc, [span.type]: spanGroup }
  }, {})
}

function sortSpansByStart(spans: Span[]): Span[] {
  return spans.sort((a, b) => a.start - b.start)
}

export function mergeOverlap(spans: Span[]): Span[] {
  const groupedByType = groupByType(spans)

  const merged = Object.entries(groupedByType)
    .map(([_type, spans]) => {
      const sortedSpans = sortSpansByStart(spans)

      return sortedSpans.reduce<Span[]>((acc, span) => {
        // First span doesn't need to be merged
        if (!acc.length) return [span]

        const lastIndex = acc.length - 1
        const lastMark = acc[lastIndex]
        if (!lastMark) return acc

        // Span starts after the last ends
        if (lastMark.end < span.start) return [...acc, span]

        // Span is fully contained in last
        if (lastMark.end >= span.end) return acc

        // Span is partially contained in last, so merge and update the end to the furthest end
        return [...acc.slice(0, lastIndex), { ...lastMark, end: span.end }]
      }, [])
    })
    .flat()

  return sortSpansByStart(merged)
}
